<template>
  <div
    class="reviewSlider"
    @touchstart="swpHandleTouchStart"
    @touchmove="swpHandleTouchMove"
    @touchend="swpHandleTouchEnd"
  >
    <div class="reviewSlider_slider-wrapper">
      <transition-group
        tag="div"
        class="reviewSlider_slider"
        :name="slideback ? 'slideback' : 'slide'"
      >
        <div
          v-for="(item, idx) in items"
          v-show="currIdx === idx"
          :key="`${idx}_${item.idx}_${l_uuid}_${idx}`"
          class="card"
        >
          <slot
            :index="idx"
            :item="item"
          >
          </slot>
        </div>
      </transition-group>
    </div>
    <div
      class="reviewSlider_btn-arrow reviewSlider_btn-arrow_left"
      :class="{ 'no-events opacity_4': !repeat && currIdx === 0 }"
      @click="go(-1)"
    >
      <i
        style="font-size: 2rem; line-height: 1; padding: 0.5rem"
        class="mdi mdi-chevron-left icon_btn"
      ></i>
    </div>
    <div
      class="reviewSlider_btn-arrow reviewSlider_btn-arrow_right"
      :class="{
        'no-events opacity_4': !repeat && currIdx === (items ? items.length - 1 : -1),
      }"
      @click="go(1)"
    >
      <i
        style="font-size: 2rem; line-height: 1; padding: 0.5rem"
        class="mdi mdi-chevron-right icon_btn"
      ></i>
    </div>
    <!-- <div class="slideshow-circles">
      <div
        class="slideshow-circle"
        :class="{ 'slideshow-circle_active': currIdx === idx }"
        @click="currIdx = idx"
        v-for="(image, idx) in items"
        :key="idx"
      ></div>
    </div> -->
  </div>
</template>

<script>
import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'ReviewSlider',
  mixins: [swipe_mix],
  props: {
    items: Array,
    repeat: { type: Boolean, default: true },
    startIndex: { default: 0 },
  },
  emits: ['go:next', 'go:prev', 'update:index'],
  data() {
    return {
      slideback: false,
      l_uuid: 0,
      currIdx: 0,
    }
  },
  methods: {
    swpLeft() {
      this.go(1)
    },
    swpRight() {
      this.go(-1)
    },
    go(num) {
      this.slideback = num === -1
      if (this.currIdx + num > this.items.length - 1) {
        this.$emit('go:next')
        if (!this.repeat) return
      }
      if (this.currIdx + num < 0) {
        this.$emit('go:prev')
        if (!this.repeat) return
      }
      this.currIdx =
        this.currIdx + num > this.items.length - 1
          ? 0
          : this.currIdx + num < 0
          ? this.items.length - 1
          : this.currIdx + num
      this.$emit('update:index', this.currIdx)
    },
  },

  watch: {
    startIndex() {
      this.currIdx = this.startIndex
    },
  },
}
</script>

<style lang="scss" scoped>
.reviewSlider {
  --radius: 4px;
  --height: 100%;
  --width: 100%;

  --inset-arrow-left: auto auto auto 0;
  --inset-arrow-right: auto 0 auto auto;

  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: var(--clr-range_empty);
  padding: 1.5rem;
  border-radius: 10px;
  transition: 0.2s;
  &_title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
    text-align: center;
    font-weight: 700;
  }
  &_text {
    background: #005b4b;
    text-shadow: var(--box-text-shadow);
    border: solid 2px var(--clr-primary);
    font-weight: 500;
    min-height: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0rem;
    border-radius: 4px;
    transition: 0.2s;
    opacity: 0;
    min-width: 33%;
    margin: 0 auto;
    &_visible {
      min-height: 2rem;
      margin-bottom: 1rem;
      padding: 0 1rem;
      opacity: 1;
    }
  }
  &_btn-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    color: white;
    z-index: 1;

    &_left {
      // left: 0;
      inset: var(--inset-arrow-left);
      // transform: translate(140%, 0);
    }
    &_right {
      // right: 0;
      inset: var(--inset-arrow-right);
      // transform: translate(-140%, 0);
    }
  }
}
.slideshow-circles {
  z-index: 4;
}
.reviewSlider_slider-wrapper {
  height: var(--height);
  width: var(--width);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: var(--radius);
}
.reviewSlider_slider {
  position: relative;
  height: 100%;
  width: 100%;
  // max-width: 100vw;
  .card {
    position: absolute;
    height: var(--height);
    width: var(--width);
    display: flex;
    justify-content: center;
    will-change: transform;
    .card-text {
      position: absolute;
      bottom: 0;
      color: white;
      z-index: 1;
    }
    img {
      height: inherit;
      width: inherit;
    }
  }
}

.slideshow-circles {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -2rem;
}
.slideshow-circle {
  border-radius: 50%;
  height: 0.875rem;
  width: 0.875rem;
  margin: 0 0.25rem;
  transition: 0.3s;
  cursor: pointer;
  background: var(--clr-grey);
  &:hover {
    background: var(--clr-primary);
  }
  &_active {
    background: var(--clr-primary);
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter-from {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.slideback-leave-active,
.slideback-enter-active {
  transition: 0.3s;
}
.slideback-enter-from {
  transform: translate(-100%, 0);
}
.slideback-leave-to {
  transform: translate(100%, 0);
}
</style>
